import {
  Avatar,
  Box,
  Button,
  Checkbox,
  createStyles,
  Divider,
  FileButton,
  Grid,
  Group,
  Loader,
  Text,
  Textarea,
  TextInput,
  Tooltip,
} from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import GreenCheck from "../../../components/Svgs/GreenCheck";
import { useMediaQuery } from "@mantine/hooks";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";
import {
  createInvoicesSetting,
  CreateStripeAccount,
  EditInvoicesSetting,
  getInvoicesSetting,
} from "../../../services/invoicesetting";
import { decrypt, encrypt } from "../../../utils";
import swal from "sweetalert";
import { uploadClientProfile } from "../../../services/patient";

const useStyles = createStyles((theme) => ({
  profile: {
    background: "#fff",
    margin: "1rem 0",
    borderRadius: "12px",
    padding: "12px 26px",
  },
  profileTitle: {
    color: "#262626",
    textAlign: "left",
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  profilePhoto: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "10px",
    marginBlock: "1rem",
  },
  paymentMethod: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "10px",
    "@media (max-width: 600px)": {
      flexWrap: "wrap",
    },
  },
  method: {
    borderRadius: "12px",
    background: "#fff",
    padding: "8px 16px",
    cursor: "pointer",
    border: "2px solid #E4E4E7",
    width: "fit-content",
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  btn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    margin: "1rem 0",
  },
  textLogo: {
    color: "#52525B",
    textAlign: "center",
    fontFamily: "Inter, sans-serif",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "32px",
  },
}));

export const InvoiceSetting = () => {
  const { classes } = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { profile } = useSelector((state) => state?.profile);
  const { settingInvoice, loading: loadingInvoice } = useSelector(
    (state) => state.settinginvoice
  );
  const [useTextLogo, setUseTextLogo] = useState(false);

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  const [checkedItems, setCheckedItems] = useState({
    debitCredit: false,
    ach: false,
    cash: false,
    cheque: false,
  });
  const openRef = useRef();

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      note: "",
    },
  });

  const { stripeaccounts } = useSelector((state) => state.settinginvoice);

  //  console.log('stripeaccounts tets',stripeaccounts.StripeAccounts.stripeAccountdetails.requirements?.currently_due);

  const currentlyDue =
    stripeaccounts?.StripeAccounts?.stripeAccountdetails?.requirements
      ?.currently_due || [];

  const fieldMessages = {
    "business_profile.mcc": "Business category (MCC code)",
    "business_profile.product_description":
      "Product description for your business",
    "business_profile.support_phone": "Support phone number",
    "business_profile.url": "Business website URL",
    external_account: "External bank account information",
    "individual.address.city": "City of the business address",
    "individual.address.line1": "Line 1 of the business address",
    "individual.address.postal_code": "Postal code of the business address",
    "individual.address.state": "State of the business address",
    "individual.dob.day": "Day of birth (individual)",
    "individual.dob.month": "Month of birth (individual)",
    "individual.dob.year": "Year of birth (individual)",
    "individual.email": "Individual's email address",
    "individual.first_name": "Individual's first name",
    "individual.last_name": "Individual's last name",
    "individual.phone": "Individual's phone number",
    "individual.ssn_last_4": "Last 4 digits of individual’s SSN",
    "settings.payments.statement_descriptor": "Payment statement descriptor",
    "tos_acceptance.date": "Date of Terms of Service acceptance",
    "tos_acceptance.ip": "IP address from which Terms of Service was accepted",
  };

  // const missingFields = currentlyDue?.map((field) => fieldMessages[field])
  const missingFields = currentlyDue.map((field) => {
    return fieldMessages[field] || field;
  });

  console.log("missingFields", missingFields);

  // Populate form values and states if invoice settings exist in Redux store
  useEffect(() => {
    if (settingInvoice?.settinginvoice) {
      form.setValues({
        name: settingInvoice?.settinginvoice.name || "",
        email: settingInvoice?.settinginvoice.email || "",
        phone: settingInvoice?.settinginvoice.phone || "",
        note: settingInvoice?.settinginvoice.note || "",
      });
      setImage(settingInvoice?.settinginvoice.image);
      setEdit(true);
      setCheckedItems(settingInvoice?.settinginvoice.paymentsOptions);
    }
  }, [settingInvoice?.settinginvoice]);

  // Function to handle image upload and processing
  const onChangePhoto = async (files) => {
    setUseTextLogo(false);
    setLoading(true);
    if (files) {
      const formData = new FormData();
      formData.append("file", files);
      const data = await uploadClientProfile(formData);
      const encryptedImageUrl = encrypt(data?.imageUrl);
      setImage(encryptedImageUrl);
      setLoading(false);
    }
    if (openRef.current) {
      openRef.current();
    }
  };

  // Available payment methods options for the invoice setting
  const paymentMethods = [
    { key: "debitCredit", label: "Debit/Credit Card" },
    { key: "ach", label: "ACH" },
    { key: "cash", label: "Cash" },
    { key: "cheque", label: "Check" },
  ];

  // Toggle individual payment method option on or off
  const handlePaymentOption = (key) => {
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const areAllSelected = Object.values(checkedItems).every(Boolean);

  // Toggle select or deselect all payment methods
  const handleSelectAllPayment = () => {
    const newVal = !areAllSelected;
    setCheckedItems({
      debitCredit: newVal,
      ach: newVal,
      cash: newVal,
      cheque: newVal,
    });
  };

  // Save or update invoice settings via API calls
  const savebtn = async () => {
    const values = form.values;

    let payload = {
      ...values,
      image,
      paymentsOptions: checkedItems,
      admin: profile.user.id,
    };

    if (edit) {
      payload.id = settingInvoice?.settinginvoice?.id;
      let res = await EditInvoicesSetting(payload);
      if (res && res.status === 200) {
        swal({
          icone: "success",
          title: "Invoice setting updated successfully",
          text: "Invoice setting updated successfully",
          dangerMode: false,
        });
        form.reset();
        await getInvoicesSetting();
      } else {
        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
      let res = await createInvoicesSetting(payload);
      if (res && res.status === 200) {
        swal({
          icon: "success",
          title: "Invoice setting created successfully",
          text: "Invoice setting created successfully",
          dangerMode: false,
        });
        form.reset();
        await getInvoicesSetting();
      } else {
        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
          dangerMode: true,
        });
      }
    }
  };

  // Reset form and state values to default
  const cancelbtn = () => {
    form.reset();
    setEdit(false);
    setImage(null);
    setCheckedItems({
      debitCredit: false,
      ach: false,
      cash: false,
      cheque: false,
    });
    setUseTextLogo(false);
    setLoading(false);
  };

  // Enable using text logo instead of an uploaded image
  const handleUseTextLogo = () => {
    setUseTextLogo(true);
  };

  // Generate a text logo based on the company name initials
  const getTextLogo = () => {
    const name = form?.values?.name?.trim();
    if (!name) return "?";
    const words = name?.split(" ");
    if (words?.length >= 2) {
      return (words[0][0] + words[words?.length - 1][0]).toUpperCase();
    }
    return words[0][0].toUpperCase();
  };

  const StripePaymentRegistration = async () => {
    setLoading(true);

    let res = await CreateStripeAccount();

    console.log("res", res);

    if (res?.data?.accountLink?.url) {
      setLoading(false);
      const url = res?.data?.accountLink?.url;
      window.location.href = url;
    }
  };

  return (
    <Box className={classes.profile}>
      <Text className={classes.profileTitle}>Company Profile</Text>
      <Box className={classes.profilePhoto}>
        {loading ? (
          <Loader size="md" radius="100%" color="yellow" />
        ) : useTextLogo ? (
          <Avatar size="xl" radius="100%">
            <Text className={classes.textLogo}>{getTextLogo()}</Text>
          </Avatar>
        ) : image ? (
          <Avatar
            src={decrypt(image)}
            alt="Company Logo"
            size="xl"
            radius="100%"
          />
        ) : (
          // Placeholder when nothing is selected yet
          <Avatar size="xl" radius="100%">
            {form.values.name ? form.values.name[0].toUpperCase() : "?"}
          </Avatar>
        )}
        <Group>
          <FileButton
            onChange={(files) => onChangePhoto(files)}
            openRef={openRef}
            accept="image/*"
          >
            {(props) => (
              <Button
                variant="filled"
                color="gray"
                size="xs"
                radius="md"
                {...props}
              >
                Add Logo
              </Button>
            )}
          </FileButton>
          <Button
            size="xs"
            radius="md"
            color="gray"
            variant="outline"
            onClick={handleUseTextLogo}
          >
            Use Text Logo
          </Button>
        </Group>
      </Box>
      {/* Hidden FileButton to trigger upload */}
      {/* <FileButton
        onChange={(files) => onChangePhoto(files)}
        openRef={openRef}
        accept="image/*"
      >
        {(props) => <div style={{ display: "none" }} {...props} />}
      </FileButton> */}

      <Divider my="sm" />
      <Box className={classes.profileInfo}>
        <Text className={classes.profileTitle}>Company Information</Text>
        <Grid mt={10}>
          <Grid.Col span={isMobile ? 12 : 4}>
            <TextInput
              label="Company Name"
              placeholder="Enter Company Name"
              radius="md"
              withAsterisk
              {...form.getInputProps("name")}
            />
          </Grid.Col>
          <Grid.Col span={isMobile ? 12 : 4}>
            <TextInput
              label="Company Email"
              placeholder="Enter Company Email"
              radius="md"
              withAsterisk
              {...form.getInputProps("email")}
            />
          </Grid.Col>
          <Grid.Col span={isMobile ? 12 : 4}>
            <TextInput
              label="Company Phone"
              placeholder="Enter Company Phone"
              type="number"
              radius="md"
              withAsterisk
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
        </Grid>
        <Textarea
          label="Invoice Note"
          placeholder="Enter Invoice Note"
          radius="md"
          autosize
          minRows={6}
          maxRows={6}
          style={{ resize: "none" }}
          variant="filled"
          size="sm"
          mt={10}
          {...form.getInputProps("note")}
        />
        <Text mt={20} className={classes.profileTitle}>
          Payment Method
        </Text>
        <Box className={classes.paymentMethod} mt={10}>
          {paymentMethods?.map((pm) => (
            <Text
              key={pm.key}
              className={classes.method}
              onClick={() => handlePaymentOption(pm.key)}
              style={{
                cursor: "pointer",
                userSelect: "none",
                border: checkedItems[pm?.key]
                  ? "2px solid #000"
                  : "2px solid #E4E4E7",
              }}
            >
              {pm?.label} {checkedItems[pm?.key] && <GreenCheck />}
            </Text>
          ))}
        </Box>
        <Box mt={10}>
          <Checkbox
            label="Select All"
            checked={areAllSelected}
            onChange={handleSelectAllPayment}
            color="gray"
            variant="outline"
          />
        </Box>

        {/* {
              (profile?.user?.stripeAccountStatus === 'pending' && settingInvoice?.settinginvoice
                ?.paymentsOptions?.debitCredit) || 
              settingInvoice?.settinginvoice
              ?.paymentsOptions?.ach

              ? 
              
              <Box mt={20}>
<Button
  color="yellow"
  loading={loading}
  size="md"
  radius="md"
  disabled={profile?.user?.stripeAccountStatus === 'complete'}
  onClick={StripePaymentRegistration}
>
  Stripe Payment Account Registration
  </Button>

  </Box>
              
              : null
            }          */}

        <Box mt={20}>
          <Button
            color="yellow"
            loading={loading}
            size="md"
            radius="md"
            disabled={!settingInvoice?.settinginvoice}
            //  disabled={stripeaccounts && stripeaccounts?.StripeAccounts?.stripeAccountStatus  === 'complete'}
            onClick={StripePaymentRegistration}
          >
            Create Stripe Payment Account Registration
            {/* { stripeaccounts &&  stripeaccounts?.StripeAccounts?.stripeAccountStatus ==='complete' ?  'Update Stripe Payment Account Registration': 'Create Stripe Payment Account Registration'} */}
          </Button>

          {!settingInvoice?.settinginvoice ? (
            <Tooltip
              label="Invoice Setting Details Incomplete"
              withArrow
              position="bottom"
            >
              <img
                width={20}
                style={{ position: "relative", left: "2px" }}
                src="/assets/images/error.png"
                alt="check-icon"
              />
            </Tooltip>
          ) : null}

          {stripeaccounts &&
          stripeaccounts?.StripeAccounts?.stripeAccountStatus === "complete" ? (
            <Text
              style={{ marginTop: "20px", marginBottom: "20px" }}
              className={classes.profileTitle}
            >
              {/* Your Stripe Account is Register Successfully You can Update Card
              details by clicking on Above button */}
              Congratulations! You are now setup to process invoices on Ogiso
            </Text>
          ) : null}
        </Box>

        <div>
          {missingFields.length > 0 && (
            <div>
              <h3>
                The following fields are required for your Stripe account:
              </h3>
              <ul>
                {missingFields.map((msg, index) => (
                  <li key={index}>{msg}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <Box className={classes.btn} mt={20}>
          <Button
            color="gray"
            size="md"
            radius="md"
            fullWidth
            onClick={cancelbtn}
          >
            Cancel
          </Button>
          <Button
            color="yellow"
            size="md"
            radius="md"
            fullWidth
            onClick={savebtn}
            loading={loadingInvoice}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
